import { render, staticRenderFns } from "./BodyAnatomyTypeInfo.vue?vue&type=template&id=3702e2a2&scoped=true&"
import script from "./BodyAnatomyTypeInfo.vue?vue&type=script&lang=js&"
export * from "./BodyAnatomyTypeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3702e2a2",
  null
  
)

export default component.exports